import React, { useEffect, useState } from 'react'
import DashboardSummary from '../DashboardSummaryNew';
import DashboardGroupedBarChart from "../DashboardGroupedBarChart";
import DashboardGaugeChart from '../DashboardGaugeChart';
import DashboardLineChart from "../DashboardLineChart";
import DashboardAreaChart from "../DashboardAreaChart";
import DashboardTable from '../DashboardTable';
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import * as tableHeaders from './tableHeaders';
import TableToolbarDownload from '../../../common/TableToolbarDownload';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import { TableToolbar, TableToolbarContent, TableToolbarSearch, ContentSwitcher, Switch, Tabs, Tab } from 'carbon-components-react'
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants';
import multiplePostRequests from "../../../requests/MultiplePostRequests";
import DataTableWithExpandedRow from './DataTableWithExpandedRow';
require("./_alert-management.scss");


const AlertManagement = (props) => {
    const [alertManagementSummaryData, setAlertManagementSummaryData] = useState([]);
    const [alertsKPILoading, setAlertsKPILoading] = useState(true);
    const [alertsKPIData, setAlertsKPIData] = useState([]);
    const [redAlertsGaugeData, setRedAlertsGaugeData] = useState([]);
    const [yellowAlertsGaugeData, setYellowAlertsGaugeData] = useState([]);
    //const [greenAlertsGaugeData, setGreenAlertsGaugeData] = useState([]);
    const [alertsClassificationData, setAlertsClassificationData] = useState([]);
    const [alertsMetricHeaders, setAlertsMetricHeaders] = useState([]);
    const [alertsMetricData, setAlertsMetricData] = useState([]);
    const [alertsMetricLoading, setAlertsMetricLoading] = useState(true);
    const [incidentVelocityTrendLoading, setIncidentVelocityTrendLoading] = useState(true);
    const [incidentVelocityTrendData, setIncidentVelocityTrendData] = useState([]);
    const [alertDistributionDataLoading, setAlertDistributionDataLoading] = useState(true);
    const [alertDistributionData, setAlertDistributionData] = useState([]);
    const [alertsMetricDownloadDataHeaders, setAlertsMetricDownloadDataHeaders] = useState([]);
    const [alertsMetricDownloadData, setAlertsMetricDownloadData] = useState([]);
    const [SelectedViewAlerts, setSelectedViewAlerts] = useState('GroupedBySID');
    const [SelectedViewInfra, setSelectedViewInfra] = useState('GroupedBySID');
    const [searchedMetricReport, setSearchedMetricReport] = useState([]);
    const [searchedValue, setSearchedValue] = useState('');
    const [infraAlertsMetricsData, setInfraAlertsMetricsData] = useState([]);
    const [infraAlertMetricsHeaders, setInfraAlertMetricsHeaders] = useState([]);
    const [infraAlertsMetricLoading, setInfraAlertsMetricLoading] = useState(true);
    const [infraAlertsMetricDownloadDataHeaders, setInfraAlertsMetricDownloadDataHeaders] = useState([]);
    const [infraAlertsMetricDownloadData, setInfraAlertsMetricDownloadData] = useState([]);
    const [searchedInfraMetricReport, setSearchedInfraMetricReport] = useState([]);
    const [searchedInfraValue, setSearchedInfraValue] = useState('');

    useEffect(() => {
        getAlertsKPI(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAlertsIncidentVelocityTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getAlertDistributionData(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        //getAlertsSummary(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        //getAlertVsIncidentVelocityTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getInfraAlertMetrics(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
        getInfraAlertsKPI(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);

    }, [props.preferencesChanged]);

    useEffect(() => {
        getAlertsMetrics(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged, SelectedViewAlerts]);

    useEffect(() => {
        getInfraAlertMetrics(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }, [props.preferencesChanged, SelectedViewInfra]);

    useEffect(() => {
        if (searchedValue !== undefined) {
            searchTable(searchedValue, 'AlertMetric');
        }
    }, [SelectedViewAlerts, alertsMetricData, searchedValue]);

    useEffect(() => {
        if (searchedInfraValue !== undefined) {
            searchTable(searchedInfraValue, 'InfraMetric');
        }
    }, [SelectedViewInfra, infraAlertsMetricsData, searchedInfraValue]);

    const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
        let timeZone = moment.tz.guess();
        let technology;
        let franchise;
        let client;
        let bodyJSON;
        // let startTime =  moment.utc(timeFilterSelections.startDateTime).format();
        // let endTime = moment.utc(timeFilterSelections.endDateTime).format();
        let startTime = timeFilterSelections.startDateTime;
        let endTime = timeFilterSelections.endDateTime;

        if (workspace === workspaces.automation_ops) {
            technology = dashboardFilterSelectionsAutomation.technology;
            franchise = dashboardFilterSelectionsAutomation.franchise;
            client = dashboardFilterSelectionsAutomation.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": startTime,
                        "endDateTime": endTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    // "alert_status": dashboardFilterSelections.alert_status, PENDING TO IMPLEMENT
                    "incident_status": dashboardFilterSelectionsAutomation.incident_status
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        } else {
            technology = ["SAP"];
            franchise = dashboardFilterSelectionsSAP.franchise;
            client = dashboardFilterSelectionsSAP.client;
            bodyJSON = {
                "filters": {
                    "time": {
                        "startDateTime": startTime,
                        "endDateTime": endTime
                    },
                    "franchises": franchise,
                    "clients": client,
                    "technologies": technology,
                    "assignment_groups": dashboardFilterSelectionsSAP.assigned_group,
                    "incident_status": dashboardFilterSelectionsSAP.incident_status,
                    "automata_priority": dashboardFilterSelectionsSAP.priority,
                    "alert_source": dashboardFilterSelectionsSAP.alert_source,
                    "alert_system_name": dashboardFilterSelectionsSAP.alert_system_name
                },
                "interval": {
                    "calender_Interval": calenderInterval,
                    "time_zone": timeZone
                },
                "workspace": workspace
            };
        }
        return bodyJSON;
    };

    const prepareSummaryData = (param) => {
        let incidentCRatio = (param.uniqueAlerts / param.totalAlerts) * 100
        let summary = [
            {
                title: DashboardConstants.TotalAlerts,
                value: param.totalAlerts
            },
            {
                title: DashboardConstants.DuplicateAlerts,
                value: param.totalDuplicateAlerts
            },
            {
                title: DashboardConstants.TicketsCreated,
                value: param.uniqueAlerts
            },
            {
                title: DashboardConstants.InformationalAlerts,
                value: Number(param.totalAlerts - (param.totalDuplicateAlerts + param.uniqueAlerts))
            },
            {
                title: DashboardConstants.IncidentConversionRatio,
                value: incidentCRatio.toFixed(2),
                showPercent: true
            },
            {
                title: DashboardConstants.EliminatedNoise,
                value: (((param.totalDuplicateAlerts + (param.totalAlerts - (param.totalDuplicateAlerts + param.uniqueAlerts))) / param.totalAlerts) * 100).toFixed(2),
                showPercent: true
            },
            {
                title: DashboardConstants.NoiseReductionforActionable,
                value: (((param.totalAlerts - Number(param.totalAlerts - (param.totalDuplicateAlerts + param.uniqueAlerts))) / param.totalAlerts) * 100).toFixed(2),
                showPercent: true
            }
        ];
        return summary;
    };
    const prepareAlertsKPIData = (response) => {
        let tableData = [];
        let tableObj;
        let duplicatedAlerts = 0, ticketConversionRate = 0, averageAnalysisTime = 0, averageResolutionTime = 0;
        let redGraphDataTotal = 0, yellowGraphDataTotal = 0, greenGraphDataTotal = 0;
        let redGraphData, yellowGraphData = [];
        let totalAlerts = 0;
        let summaryData, totalDuplicateAlerts = 0, uniqueAlerts = 0;
        let chartData = [], tableDataArr = [];
        let totalGroupGraphObj = {};
        let uniqueGroupGraphObj = {};
        let infraClientArr = [], unique = [], chartDataArr = [];

        for (let j = 0; j < response.length; j++) {
            let buckets = j === 0 ? response[j].data.aggregations.client.buckets : response[j].data.aggregations['client name'].buckets;
            if (j === 0) {
                for (let i = 0; i < buckets.length; i++) {
                    duplicatedAlerts = buckets[i].total.buckets.ticketed.count.value - buckets[i].tickets.unique_count.value;
                    ticketConversionRate = ((buckets[i].tickets.unique_count.value) / (buckets[i].total.buckets.alerts.count.value)) * 100;
                    averageAnalysisTime = buckets[i].tickets.TicketingElapse.value;
                    averageResolutionTime = buckets[i].tickets.ResolutionElapse.value;
                    tableObj = {
                        id: Math.random(),
                        engagement: buckets[i].key,
                        ticketedAlerts: buckets[i].tickets.unique_count.value,
                        duplicatedAlerts: duplicatedAlerts || 0,
                        nonTicketsAlerts: buckets[i]["total-non-ticketed"].value,
                        ticketConversionRate: isNaN(ticketConversionRate) ? 0 : (ticketConversionRate).toFixed(2),
                        avgAlertAnalysisTime: averageAnalysisTime ? (averageAnalysisTime).toFixed(2) : 0,
                        avgAlertResolutionTime: averageResolutionTime ? (averageResolutionTime).toFixed(2) : 0,
                        totalAlerts: buckets[i].total.buckets.alerts.count.value
                    };

                    tableObj.red = buckets[i]["Red-Alerts"].count.value ? buckets[i]["Red-Alerts"].count.value : 0;
                    redGraphDataTotal = redGraphDataTotal + (buckets[i]["Red-Incidents"].count.value || 0);
                    tableObj.yellow = buckets[i]["Yellow-Alerts"].count.value ? buckets[i]["Yellow-Alerts"].count.value : 0;
                    yellowGraphDataTotal = yellowGraphDataTotal + (buckets[i]["Yellow-Incidents"].value || 0);
                    tableData.push(tableObj);
                    totalAlerts = totalAlerts + buckets[i].total.buckets.alerts.count.value;
                    uniqueAlerts = uniqueAlerts + buckets[i].tickets.unique_count.value;
                    totalDuplicateAlerts = totalDuplicateAlerts + duplicatedAlerts;
                    summaryData = {
                        totalAlerts: totalAlerts,
                        totalDuplicateAlerts: totalDuplicateAlerts,
                        uniqueAlerts: uniqueAlerts
                    }

                    //gauge data
                    redGraphData = [
                        {
                            "group": "value",
                            "value": redGraphDataTotal || 0
                        }
                    ];
                    yellowGraphData = [
                        {
                            "group": "value",
                            "value": yellowGraphDataTotal || 0
                        }
                    ]

                    //graph data
                    totalGroupGraphObj = {
                        "group": 'Alerts',
                        "key": buckets[i].key,
                        "value": buckets[i].total.buckets.alerts.count.value
                    };
                    uniqueGroupGraphObj = {
                        "group": 'Incidents',
                        "key": buckets[i].key,
                        "value": buckets[i].tickets.unique_count.value
                    };
                    chartData.push(totalGroupGraphObj, uniqueGroupGraphObj);
                }
            }
            else {
                let totInfraAlerts = 0, totInfraTickets = 0, dupInfraAlerts = 0;
                for (let i = 0; i < buckets.length; i++) {
                    totInfraAlerts = totInfraAlerts + buckets[i].total.buckets.alerts.count.value;
                    totInfraTickets = totInfraTickets + buckets[i].tickets.unique_count.value; //unique alerts
                    dupInfraAlerts = dupInfraAlerts + (buckets[i].total.buckets.ticketed.count.value - buckets[i].tickets.unique_count.value);
                }

                summaryData.totalAlerts = Number(summaryData.totalAlerts) + Number(totInfraAlerts);
                summaryData.totalDuplicateAlerts = Number(summaryData.totalDuplicateAlerts) + Number(dupInfraAlerts);
                summaryData.uniqueAlerts = Number(summaryData.uniqueAlerts) + Number(totInfraTickets);


                for (let i = 0; i < buckets.length; i++) {
                    for (let j = 0; j < tableData.length; j++) {

                        //infra and application common clients data
                        if (buckets[i].key === tableData[j].engagement) {
                            let dAlerts = buckets[i].total.buckets.ticketed.count.value - buckets[i].tickets.unique_count.value;

                            let infraAverageAnalysisTime = buckets[i].tickets.TicketingElapse.value ? (buckets[i].tickets.TicketingElapse.value).toFixed(2) : 0;
                            let infraAverageResolutionTime = buckets[i].tickets.ResolutionElapse.value ? (buckets[i].tickets.ResolutionElapse.value).toFixed(2) : 0;

                            tableData[j].duplicatedAlerts = tableData[j].duplicatedAlerts + dAlerts;
                            tableData[j].nonTicketsAlerts = tableData[j].nonTicketsAlerts + buckets[i]["total-non-ticketed"].value;//informational alerts
                            tableData[j].ticketedAlerts = tableData[j].ticketedAlerts + buckets[i].tickets.unique_count.value;
                            let infraTicketCR = (tableData[j].ticketedAlerts / (tableData[j].totalAlerts + (buckets[i].total.buckets.alerts.count.value))) * 100;
                            tableData[j].ticketConversionRate = infraTicketCR.toFixed(2);
                            tableData[j].avgAlertAnalysisTime = (Number(tableData[j].avgAlertAnalysisTime) + Number(infraAverageAnalysisTime)).toFixed(2) / 2;
                            tableData[j].avgAlertResolutionTime = (Number(tableData[j].avgAlertResolutionTime) + Number(infraAverageResolutionTime)).toFixed(2) / 2;
                        }
                    }


                }
                // if the clients are same then adds the total tickets and alerts
                for (let i = 0; i < buckets.length; i++) {
                    let infraTotalGroupGraphObj = {
                        "group": 'Alerts',
                        "key": buckets[i].key,
                        "value": buckets[i].total.buckets.alerts.count.value
                    };
                    let infraUniqueGroupGraphObj = {
                        "group": 'Incidents',
                        "key": buckets[i].key,
                        "value": buckets[i].tickets.unique_count.value
                    };
                    chartData.push(infraTotalGroupGraphObj, infraUniqueGroupGraphObj);
                }

                let resDataArr = chartData.reduce(function (acc, val) {
                    var o = acc.filter(function (obj) {
                        return obj.key == val.key && obj.group === val.group;
                    }).pop() || { key: val.key, group: val.group, value: 0 };

                    o.value += val.value;
                    acc.push(o);
                    return acc;
                }, []);

                let arr1 = [], arr2 = [];
                resDataArr.map((item) => {
                    if (item.group === 'Alerts') arr1.push(item);
                    else arr2.push(item);
                })
                let dataArr1 = [
                    ...new Map(arr1.map((item) => [item['key'], item])).values(),
                ];
                let dataArr2 = [
                    ...new Map(arr2.map((item) => [item['key'], item])).values(),
                ];

                chartDataArr = dataArr1.concat(dataArr2);

                let commonKey = [];

                tableData.map((item) => {
                    buckets.map((infraItem) => {
                        if (item.engagement === infraItem.key) {
                            commonKey.push(item.engagement);
                        }
                    })
                })

                if (commonKey.length > 0) {
                    for (let k = 0; k < commonKey.length; k++) {
                        for (let i = 0; i < buckets.length; i++) {

                            if (commonKey[k] !== buckets[i].key) {
                                let dAlerts = buckets[i].total.buckets.ticketed.count.value - buckets[i].tickets.unique_count.value;
                                let infraTicketCR = ((buckets[i].tickets.unique_count.value) / (buckets[i].total.buckets.alerts.count.value)) * 100;
                                let infraAverageAnalysisTime = buckets[i].tickets.TicketingElapse.value ? (buckets[i].tickets.TicketingElapse.value).toFixed(2) : 0;
                                let infraAverageResolutionTime = buckets[i].tickets.ResolutionElapse.value ? (buckets[i].tickets.ResolutionElapse.value).toFixed(2) : 0;

                                let infraTableObj = {
                                    id: Math.random(),
                                    engagement: buckets[i].key,
                                    ticketedAlerts: buckets[i].tickets.unique_count.value,
                                    duplicatedAlerts: dAlerts || 0,
                                    nonTicketsAlerts: buckets[i]["total-non-ticketed"].value || 0,
                                    ticketConversionRate: isNaN(infraTicketCR) ? 0 : (infraTicketCR).toFixed(2),
                                    avgAlertAnalysisTime: infraAverageAnalysisTime,
                                    avgAlertResolutionTime: infraAverageResolutionTime,
                                    red: '-',
                                    yellow: '-'
                                };
                                infraClientArr.push(infraTableObj);
                            }

                        }

                    }

                    let DataArr = tableData.concat(infraClientArr);
                    const uniqueIds = [];

                    tableDataArr = DataArr.filter(element => {
                        const isDuplicate = uniqueIds.includes(element.engagement);

                        if (!isDuplicate) {
                            uniqueIds.push(element.engagement);

                            return true;
                        }
                        return false;
                    });
                    //tableDataArr = tableData.concat(unique);

                }
                else {
                    for (let i = 0; i < buckets.length; i++) {
                        let dAlerts = buckets[i].total.buckets.ticketed.count.value - buckets[i].tickets.unique_count.value;
                        let infraTicketCR = ((buckets[i].tickets.unique_count.value) / (buckets[i].total.buckets.alerts.count.value)).toFixed(2) * 100;
                        let infraAverageAnalysisTime = buckets[i].tickets.TicketingElapse.value ? (buckets[i].tickets.TicketingElapse.value).toFixed(2) : 0;
                        let infraAverageResolutionTime = buckets[i].tickets.ResolutionElapse.value ? (buckets[i].tickets.ResolutionElapse.value).toFixed(2) : 0;

                        let infraTableObj = {
                            id: Math.random(),
                            engagement: buckets[i].key,
                            ticketedAlerts: buckets[i].tickets.unique_count.value,
                            duplicatedAlerts: dAlerts || 0,
                            nonTicketsAlerts: buckets[i]["total-non-ticketed"].value || 0,
                            ticketConversionRate: isNaN(infraTicketCR) ? 0 : (infraTicketCR).toFixed(2),
                            avgAlertAnalysisTime: infraAverageAnalysisTime,
                            avgAlertResolutionTime: infraAverageResolutionTime,
                            red: '-',
                            yellow: '-'
                        };
                        infraClientArr.push(infraTableObj);
                    }
                }
                if (commonKey.length === 0) {
                    tableDataArr = tableData.concat(infraClientArr);
                }
            }

        }
        return { tableDataArr, summaryData, chartDataArr, redGraphData, yellowGraphData };

    };

    const getAlertsKPI = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAlertsKPILoading(true);
            let formattedData = [], formattedSummary = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            multiplePostRequests([Constants.GETALERTSKPI, Constants.GETINFRAALERTSKPI], {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareAlertsKPIData(resp);
                    formattedSummary = prepareSummaryData(formattedData.summaryData);
                    setAlertsKPIData(formattedData.tableDataArr);
                    setAlertManagementSummaryData(formattedSummary);
                    setAlertsClassificationData(formattedData.chartDataArr);
                    setRedAlertsGaugeData(formattedData.redGraphData);
                    setYellowAlertsGaugeData(formattedData.yellowGraphData);
                    // setGreenAlertsGaugeData(formattedData.greenGraphData);
                    setAlertsKPILoading(false);
                }).catch((error) => {
                    setAlertsKPILoading(false);
                });
        }
    }

    const prepareAlertsMetricData = (response) => {
        if (response) {
            let tableData = [], expandedTable = [], sourceName = [], sourceprovider = [], sourceProviderObj = {};
            let expandedItemObj;
            let downloadableDataObj;
            let downloadableData = [];
            let entityBucket, histogramBucket;
            let key, keyAsString;
            let buckets = response.aggregations.alert_name.buckets;
            let headers = [{
                key: "item",
                header: DashboardConstants.Alert
            }];
            let downloadableHeaders = [{
                key: "alertItem",
                header: DashboardConstants.Alert,
            }, {
                key: "entity",
                header: SelectedViewAlerts === 'GroupedBySID' ? DashboardConstants.SID : DashboardConstants.Entity,
            },
            ];
            for (let i = 0; i < buckets.length; i++) {
                tableData[i] = {
                    id: i,
                    item: buckets[i].key,
                    total: 0
                }
                expandedTable = [];
                entityBucket = buckets[i].entity.buckets;
                for (let j = 0; j < entityBucket.length; j++) {
                    let expandedtotal = 0;
                    histogramBucket = entityBucket[j].histogram.buckets;
                    expandedItemObj = {
                        item: entityBucket[j].key
                    }
                    downloadableDataObj = {
                        entity: entityBucket[j].key
                    }
                    for (let k = 0; k < histogramBucket.length; k++) {
                        keyAsString = histogramBucket[k]["key_as_string"];
                        key = 'date' + k;
                        if (i === 0 && j === 0) {
                            headers[k + 1] = {
                                key: key,
                                header: keyAsString ? moment(new Date(keyAsString)).format("YYYY-MM-DD") : ''
                            }
                            downloadableHeaders[k + 2] = {
                                key: key,
                                header: keyAsString ? moment(new Date(keyAsString)).format("YYYY-MM-DD") : ''
                            }
                        }
                        expandedItemObj[key] = histogramBucket[k].alert_time_value.value; //entity bucket , j.key
                        expandedItemObj.id = (j + 1).toString();
                        downloadableDataObj[key] = histogramBucket[k].alert_time_value.value;
                        downloadableDataObj.id = (j + 1).toString();
                        downloadableDataObj.alertItem = buckets[i].key;
                        expandedtotal = expandedtotal + (histogramBucket[k].alert_time_value.value ? histogramBucket[k].alert_time_value.value : 0);
                        expandedItemObj['expandedtotal'] = expandedtotal;
                    }
                    expandedTable.push(expandedItemObj);
                    expandedTable.sort((a, b) => { return a.expandedtotal - b.expandedtotal }).reverse();
                    downloadableData.push(downloadableDataObj)
                }
                // calculating total to display
                expandedTable.reduce(function (accumulator, item, index) {
                    let total = 0;
                    Object.keys(item).forEach(function (key, i) {
                        accumulator[key] = (accumulator[key] || 0) + item[key];
                    });
                    for (let j = 0; j < Object.keys(item).length; j++) {
                        tableData[i]['date' + j] = accumulator['date' + j] ? accumulator['date' + j] : 0;
                    }
                    let datekeys = Object.keys(accumulator).filter(key => key.includes('date'))
                    for (let l = 0; l < datekeys.length; l++) {
                        total = total + (accumulator[datekeys[l]] ? accumulator[datekeys[l]] : 0);
                        tableData[i]['total'] = total;
                    }
                    return accumulator;
                }, {});

                tableData[i].expandedItems = expandedTable;
            }
            setAlertsMetricHeaders(headers);
            setAlertsMetricDownloadDataHeaders(downloadableHeaders);
            tableData.sort((a, b) => { return a.total - b.total }).reverse();
            return { tableData, downloadableData };
        }
    }

    const getAlertsMetrics = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAlertsMetricLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            bodyJSON["GroupedBy"] = SelectedViewAlerts;
            callPostApi(Constants.GETALERTSMETRICS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    setAlertsMetricLoading(false);
                    formattedData = prepareAlertsMetricData(resp);
                    setAlertsMetricData(formattedData.tableData);
                    setAlertsMetricDownloadData(formattedData.downloadableData)
                }).catch((error) => {
                    setAlertsMetricLoading(false);
                });
        }
    }

    const prepareIncidentVelocityTrend = (response) => {
        console.log(response, "resp");
        let data1 = []; let data2 = []; let data = [];
        let objTotalTickets = {};
        let objTicketsCreated = {};
        for (let j = 0; j < response.length; j++) {
            if (response[j].data) {
                let buckets = j === 0 ? response[j].data.aggregations.client.buckets : response[j].data.aggregations.Time.buckets;
                for (let i = 0; i < buckets.length; i++) {
                    objTotalTickets = {
                        group: 'Alerts',
                        date: moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD"),
                        value: j === 0 ? (buckets[i].total.buckets.alerts.count.value).toFixed(2) : (buckets[i].total.buckets.alerts.count.value).toFixed(2)
                    };
                    objTicketsCreated = {
                        group: 'Incidents',
                        date: moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD"),
                        value: j === 0 ? (buckets[i].tickets.unique_count.value).toFixed(2) : (buckets[i].tickets.unique_count.value).toFixed(2)
                    };
                    if (j === 0) {
                        data1.push(objTotalTickets);
                        data1.push(objTicketsCreated);
                    }
                    else {
                        data2.push(objTotalTickets);
                        data2.push(objTicketsCreated);
                    }
                }
            }
        }
        data1.map((item) => {
            data2.map((dataItem) => {
                if (item['group'] === dataItem['group'] && item['date'] === dataItem['date']) {
                    item['value'] = Number(item['value']) + Number(dataItem['value']);
                }
            })
            data.push(item);
        })
        return data;
    }

    const getAlertsIncidentVelocityTrend = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setIncidentVelocityTrendLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            multiplePostRequests([Constants.GETALERTINCIDENTVELOCITYTREND, Constants.GETINFRAVELOCITYANDCOUNT], {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareIncidentVelocityTrend(resp);
                    setIncidentVelocityTrendData(formattedData);
                    setIncidentVelocityTrendLoading(false);
                }).catch((error) => {
                    setIncidentVelocityTrendLoading(false);
                });
        }
    }

    const prepareAlertDistributionData = (response) => {
        let data = [];
        let applicationAlertCount = {};
        let infraAlertCount = {};
        if (response.length) {
            let applicationAlertCountBucket = response[0].data.aggregations.Time.buckets;
            let infraAlertCountBucket = response[1].data.aggregations.Time.buckets;
            for (let i = 0; i < applicationAlertCountBucket.length; i++) {
                applicationAlertCount = {
                    group: 'Application Alert',
                    date: moment(new Date(applicationAlertCountBucket[i].key_as_string)).format("YYYY-MM-DD"),
                    value: (applicationAlertCountBucket[i].total.buckets.alerts.app_alert_count.value).toFixed(2)
                };
                infraAlertCount = {
                    group: 'Infra Alert',
                    date: moment(new Date(infraAlertCountBucket[i].key_as_string)).format("YYYY-MM-DD"),
                    value: (infraAlertCountBucket[i].total.buckets.alerts.count.value).toFixed(2)
                };
                data.push(applicationAlertCount);
                data.push(infraAlertCount);
            }
        }
        return data;
    }

    const getAlertDistributionData = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setAlertDistributionDataLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            multiplePostRequests([Constants.GETAPPLICATIONALERTCOUNT, Constants.GETINFRAVELOCITYANDCOUNT], {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareAlertDistributionData(resp);
                    setAlertDistributionData(formattedData);
                    setAlertDistributionDataLoading(false);
                }).catch((error) => {
                    setAlertDistributionDataLoading(false);
                });
        }
    }

    const getApplicationAlertCount = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            // setIncidentVelocityTrendLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETAPPLICATIONALERTCOUNT, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    // setIncidentVelocityTrendLoading(false);
                }).catch((error) => {
                    // setIncidentVelocityTrendLoading(false);
                });
        }
    }

    const getInfraAlertsCount = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            // setIncidentVelocityTrendLoading(true);
            let formattedData = [];
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            callPostApi(Constants.GETINFRAALERTCOUNT, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    // setIncidentVelocityTrendLoading(false);
                }).catch((error) => {
                    // setIncidentVelocityTrendLoading(false);
                });
        }
    }

    function filterObj(keys, obj) {
        const newObj = {};
        Object.keys(obj).forEach(key => {
            if (!keys.includes(key)) {
                newObj[key] = obj[key];
            }
        });
        return newObj;
    }

    const prepareInfraAlertMetricsData = (response) => {
        if (response) {
            let tableData = [], tableObj = {}, SPArr = [], SNArr = [], SNObj = {}, expandedLevel1Obj = {}, keyArr = [], downloadableDataObj = {}, downloadableData = [];
            let sourceNameBucket, sourceProviderBucket;
            let key, keyAsString;
            let buckets = response.aggregations['Alert Name'].buckets;
            let headers = [{
                key: "item",
                header: DashboardConstants.Alert
            }];
            let downloadableHeaders = [{
                key: "alertItem",
                header: DashboardConstants.Alert,
            }, {
                key: "sourceProvider",
                header: "Source Provider",
            },
            {
                key: "sourceName",
                header: "Source Name",
            }
            ];
            for (let i = 0; i < buckets.length; i++) {
                SPArr = [];
                tableObj = {
                    id: (i + 1).toString(),
                    item: buckets[i].key,
                    total: 0
                };
                sourceProviderBucket = buckets[i]['Source Provider'].buckets;
                for (let j = 0; j < sourceProviderBucket.length; j++) {
                    let expandedtotal = 0; SNArr = [];
                    expandedLevel1Obj = {
                        id: (j + 1).toString(),
                        item: sourceProviderBucket[j].key
                    };
                    SPArr.push(expandedLevel1Obj);
                    tableObj.expandedItems = SPArr;

                    sourceNameBucket = sourceProviderBucket[j]['Source Name'].buckets;
                    for (let k = 0; k < sourceNameBucket.length; k++) {
                        SNObj = {
                            id: Math.random() + (k + 1).toString(),
                            item: sourceNameBucket[k].key
                        }
                        downloadableDataObj = {
                            sourceName: sourceNameBucket[k].key
                        }
                        let timeBuckets = sourceNameBucket[k] && sourceNameBucket[k]['Time'].buckets ? sourceNameBucket[k]['Time'].buckets : [];
                        for (let l = 0; l < timeBuckets.length; l++) {
                            keyAsString = timeBuckets[l]["key_as_string"];
                            let date = moment(new Date(keyAsString)).format("YYYY-MM-DD");
                            key = 'date' + keyArr.length + 1;
                            if (!keyArr.includes(date)) {
                                headers[keyArr.length + 1] = {
                                    key: key,
                                    header: keyAsString ? moment(new Date(keyAsString)).format("YYYY-MM-DD") : ''
                                }
                                downloadableHeaders[keyArr.length + 3] = {
                                    key: key,
                                    header: keyAsString ? moment(new Date(keyAsString)).format("YYYY-MM-DD") : ''
                                }
                                SNObj[key] = timeBuckets[l] && timeBuckets[l] && timeBuckets[l]['Alert Time'] && timeBuckets[l]['Alert Time'].value ? timeBuckets[l]['Alert Time'].value : 0;
                                keyArr.push(moment(new Date(keyAsString)).format("YYYY-MM-DD"));
                            }
                            else {
                                let index = keyArr.indexOf(date);
                                key = 'date' + index + 1;
                                SNObj[key] = timeBuckets[l] && timeBuckets[l] && timeBuckets[l]['Alert Time'] && timeBuckets[l]['Alert Time'].value ? timeBuckets[l]['Alert Time'].value : 0;
                            }
                            downloadableDataObj[key] = timeBuckets[l] && timeBuckets[l] && timeBuckets[l]['Alert Time'] && timeBuckets[l]['Alert Time'].value ? timeBuckets[l]['Alert Time'].value : 0;
                            downloadableDataObj.id = (k).toString();
                            downloadableDataObj.alertItem = buckets[i].key;
                            downloadableDataObj.sourceProvider = sourceProviderBucket[j].key;
                            expandedtotal = expandedtotal + (timeBuckets[l] && timeBuckets[l]['Alert Time'] && timeBuckets[l]['Alert Time'].value ? timeBuckets[l]['Alert Time'].value : 0);
                            tableObj['total'] = expandedtotal;
                            downloadableData.push(downloadableDataObj);

                        }
                        SNArr.push(SNObj);
                        //SNArr.sort((a, b) => { return a.expandedtotal - b.expandedtotal }).reverse();
                    }
                    expandedLevel1Obj.expandedItems = SNArr;

                }

                tableData.push(tableObj);
                SNArr.reduce(function (accumulator, item, index) {
                    let total = 0; let keyArray = [];
                    keyArray.push(Object.keys(item));
                    let newArr = [];
                    for (let i = 0; i < keyArr.length; i++) {
                        if (keyArr[i] !== 'id' && keyArr[i] !== 'item') {
                            newArr.push(keyArr[i]);
                        }
                    }
                    Object.keys(item).forEach(function (key, i) {
                        accumulator[key] = (accumulator[key] || 0) + item[key];
                    });
                    let keys = ['id', 'item'];
                    let a = filterObj(keys, accumulator);

                    for (const [key, value] of Object.entries(a)) {
                        tableData[i][key] = value;
                    }
                    let datekeys = Object.keys(accumulator).filter(key => key.includes('date'))
                    for (let l = 0; l < datekeys.length; l++) {
                        total = total + (accumulator[datekeys[l]] ? accumulator[datekeys[l]] : '-');
                        tableData[i]['total'] = total ? total : 0;
                    }
                    return accumulator ? accumulator : 0;
                }, {});
            }
            setInfraAlertsMetricDownloadDataHeaders(downloadableHeaders);
            setInfraAlertMetricsHeaders(headers);
            setInfraAlertsMetricDownloadData(downloadableData);
            tableData.map((tableItem) => {
                headers.map((headerItem) => {
                    if (headerItem.key.includes('date')) {
                        if (!tableItem.hasOwnProperty(headerItem.key)) {
                            tableItem[headerItem.key] = '-';
                        }
                    }
                })
            })
            //tableData.sort()
            console.log(tableData, "table");
            return tableData;
        }
    }

    const getInfraAlertMetrics = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            setInfraAlertsMetricLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            bodyJSON["GroupedBy"] = SelectedViewInfra;
            let formattedData = [];
            callPostApi(Constants.GETINFRAALERTMETRICS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareInfraAlertMetricsData(resp);
                    setInfraAlertsMetricsData(formattedData);
                    setInfraAlertsMetricLoading(false);
                }).catch((error) => {
                    setInfraAlertsMetricLoading(false);
                });
        }
    }

    const getInfraAlertsKPI = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            // setInfraAlertsMetricLoading(true);
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            let formattedData = [];
            callPostApi(Constants.GETINFRAALERTSKPI, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    // formattedData = prepareInfraAlertMetricsData(resp);
                    // setInfraAlertsMetricsData(formattedData);
                    // setInfraAlertsMetricLoading(false);
                }).catch((error) => {
                    // setInfraAlertsMetricLoading(false);
                });
        }
    }

    const switchView = (e, type) => {
        if (type === "InfraMetric") {
            setSelectedViewInfra(e.name);
        }
        else if (type === "AlertMetric") {
            setSelectedViewAlerts(e.name);
        }
    };

    const searchTable = (e, metric) => {
        let searchString = (e).toUpperCase();
        let searchResult = [];
        let newList = [];
        let string, pattern;
        let matchedStrings;
        if (searchString) {
            let metricData = metric === 'AlertMetric' ? alertsMetricData : infraAlertsMetricsData;
            newList = metricData.filter(element => {
                for (var property in element) {
                    if (element.hasOwnProperty(property)) {
                        if (element[property] && property !== "id" && property !== "total") {
                            string = element[property];
                        }
                        else string = '';
                        string = string ? string.toString() : '';
                        pattern = new RegExp('(\\w*' + searchString + '\\w*)', 'gi');
                        matchedStrings = string.match(pattern);
                        if (matchedStrings && matchedStrings.length) {
                            searchResult = searchResult.concat([element]);
                            return searchResult;
                        }
                    }
                }
            });
            metric === 'AlertMetric' ? setSearchedMetricReport(newList) : setSearchedInfraMetricReport(newList);
        } else {
            metric === 'AlertMetric' ? setSearchedMetricReport([]) : setSearchedInfraMetricReport([]);
        }
    };


    return (
        <div className="top-margin dashboard alert-management">
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer col-lg-12">
                    <DashboardSummary loading={alertsKPILoading} summary={alertManagementSummaryData} title={DashboardConstants.AlertManagement} />
                </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                        <div>{DashboardConstants.DetailedView}</div>
                    </div>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardLineChart lineGraphData={incidentVelocityTrendData} title={DashboardConstants.IncidentVelocityTrend} loading={incidentVelocityTrendLoading} graphTitle={DashboardConstants.Count} modalTitle="" />
                            </div>
                            <div className="report-container">
                                <DashboardAreaChart areaGraphData={alertDistributionData} title={DashboardConstants.AlertDistribution} loading={alertDistributionDataLoading} graphTitle={DashboardConstants.Count} graphBottomTitle={DashboardConstants.Count} modalTitle="" />
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="tile-view">
                            <div className="report-container">
                                <DashboardGroupedBarChart
                                    loading={alertsKPILoading}
                                    groupedBarChartData={alertsClassificationData}
                                    title={DashboardConstants.ClientWiseAlertDistribution}
                                    graphBottomTitle={DashboardConstants.Engagement}
                                    graphAxesTitle={DashboardConstants.Count}
                                />
                            </div>
                            <div className="report-container">
                                <div className="graph-title carbon-display-Regular-20">
                                    <div>{DashboardConstants.TicketedAlertsGauge}</div>
                                </div>
                                <div className="gauge-report">
                                    <div className="gauge-container">
                                        {/* <div>
                                   <DashboardGaugeChart
                                    loading={alertsKPILoading}
                                    gaugeChartData={greenAlertsGaugeData}
                                    title={DashboardConstants.GreenAlerts}
                                    color="#198038"/></div> */}
                                        <div>
                                            <DashboardGaugeChart
                                                loading={alertsKPILoading}
                                                gaugeChartData={yellowAlertsGaugeData}
                                                title={DashboardConstants.YellowAlerts}
                                                color="#F1C21B"
                                            />
                                        </div>
                                        <div>
                                            <DashboardGaugeChart
                                                loading={alertsKPILoading}
                                                gaugeChartData={redAlertsGaugeData}
                                                title={DashboardConstants.RedAlerts}
                                                color="#DA1E28"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title">
                            <div className="carbon-display-Regular-20">{DashboardConstants.AlertKPI}</div>
                            <div className="table-toolbar">
                                <TableToolbar>
                                    <TableToolbarContent>
                                        {/* <TableToolbarSearch  /> */}
                                    </TableToolbarContent>
                                </TableToolbar>
                                <div className="download-button">
                                    <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={alertsKPIData} headers={tableHeaders.alertKpiTableHeaders} title={DashboardConstants.AlertKPI} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                                </div>
                            </div>
                        </div>
                        <div className="bold-border-table">
                            <DashboardTable loading={alertsKPILoading} rows={alertsKPIData} headers={tableHeaders.alertKpiTableHeaders}
                                showPagination={true} isSortable={true} />
                        </div>
                    </section>
                    <section className="border-bottom">
                        <div className="graph-title">
                            <div className="title carbon-display-Regular-20">{DashboardConstants.AlertMetric}</div>
                        </div>
                        <Tabs>
                            <Tab label={DashboardConstants.ApplicationAlertMetric}>
                                <div className="alert-metrics">
                                    <div className="graph-title">
                                        {/* <div className="title carbon-display-Regular-20">{DashboardConstants.AlertMetric}</div> */}
                                        <div className="table-toolbar">
                                            <TableToolbar>
                                                <TableToolbarContent>
                                                    <ContentSwitcher onChange={(e) => switchView(e, "AlertMetric")} className="content-switcher" >
                                                        <Switch name={'GroupedBySID'} text={DashboardConstants.GroupedBySID} />
                                                        <Switch name={'GroupedByEntity'} text={DashboardConstants.GroupedByEntity} />
                                                    </ContentSwitcher>
                                                    <TableToolbarSearch onChange={(e) => { setSearchedValue(e.target.value); searchTable(e.target.value, "AlertMetric") }} className="search-button" />
                                                </TableToolbarContent>
                                            </TableToolbar>
                                            <div className="download-button">
                                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={alertsMetricDownloadData} headers={alertsMetricDownloadDataHeaders} title={DashboardConstants.AlertMetric} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bold-border-table nested-table">
                                        <DashboardTable loading={alertsMetricLoading} rows={searchedValue.length ? searchedMetricReport : alertsMetricData} headers={alertsMetricHeaders}
                                            showPagination={true} isSortable={true} isExpandable={true} expandedTableTitle={SelectedViewAlerts === "GroupedByEntity" ? DashboardConstants.Entity : DashboardConstants.SID} />
                                    </div>
                                </div>
                            </Tab>
                            <Tab label={DashboardConstants.InfraAlertMetric}>
                                <div className="infra-alert-metrics expanded-alert-table">
                                    <div className="graph-title">
                                        {/* <div className="carbon-display-Regular-20">Infra Alert Metric</div> */}
                                        <div className="table-toolbar">
                                            <TableToolbar>
                                                <TableToolbarContent>
                                                    <ContentSwitcher onChange={(e) => switchView(e, "InfraMetric")} className="content-switcher">
                                                        <Switch name={'GroupedBySID'} text={DashboardConstants.GroupedBySourceSID} />
                                                        <Switch name={'GroupedBySourceName'} text={DashboardConstants.GroupedBySourceName} />
                                                    </ContentSwitcher>
                                                    <TableToolbarSearch onChange={(e) => { setSearchedInfraValue(e.target.value); searchTable(e.target.value, "InfraMetric") }} className="search-button" />
                                                </TableToolbarContent>
                                            </TableToolbar>
                                            <div className="download-button">
                                                <TableToolbarDownload iconDescription={DashboardConstants.Export} rows={infraAlertsMetricDownloadData} headers={infraAlertsMetricDownloadDataHeaders} title={DashboardConstants.InfraAlertMetric} filename={DashboardConstants.Export} label={DashboardConstants.Download} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bold-border-table nested-table infra-alert-metrics-table">
                                        <DataTableWithExpandedRow
                                            rows={searchedInfraValue.length ? searchedInfraMetricReport : infraAlertsMetricsData}
                                            headers={infraAlertMetricsHeaders}
                                            isExpandable={true}
                                            expandedTableTitle={DashboardConstants.SourceProvider}
                                            expandedTableL2Title={SelectedViewInfra === "GroupedBySourceName" ? DashboardConstants.SourceName : DashboardConstants.SourceSID}
                                            showPagination={true}
                                            isSortingAllowed={true}
                                            loading={infraAlertsMetricLoading}
                                        />
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
                    </section>
                </div>
            </div>
        </div>
    );
};
export default AlertManagement;
